import { render } from "./FilterDropdown.vue?vue&type=template&id=724fa606&scoped=true"
import script from "./FilterDropdown.vue?vue&type=script&lang=js"
export * from "./FilterDropdown.vue?vue&type=script&lang=js"

import "./FilterDropdown.vue?vue&type=style&index=0&id=724fa606&scoped=true&lang=scss"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142212-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724fa606"]])

export default __exports__